/**
 * gallery
 */

import Page from '~/page/page';
import Slider from '~/slider/slider';

export default class Gallery extends Slider {
  init() {
    const elements = {
      slider: '.js-gallery-slides',
      prev: '.js-gallery-prev',
      next: '.js-gallery-next'
    };

    const options = {
      centerMode: true,
      slidesToShow: 1,
      centerPadding: '0',
      speed: '800',
      cssEase: 'ease-in-out',
      variableWidth: true
    };

    this.set(elements, options);
    this.setActiveSlide(0);
  }
  events() {
    this.$.slider.on('afterChange', (e, slick, index) => {
      this.setActiveSlide(index);
    });
  }
  setActiveSlide(index) {
    const slick = this.$.slider.slick('getSlick');

    const $slides = slick.$slides;
    const $slide = $slides.eq(index);

    $slides.removeClass('is-active');
    $slide.addClass('is-active');
  }
}

Page.mount(Gallery, '.js-gallery');
